module.exports = __webpack_public_path__ + "img/iconography-2.d75f6997.jpg";